<div class="containerManageDialogue d-flex flex-column">
  <div class="topHead d-flex justify-content-between">
    <span>Update History- {{ data[0].mem_key }}</span>
    <div class="close-button" mat-button mat-dialog-close>
      <mat-icon class="close-icon">close</mat-icon>
    </div>
  </div>
  @for(list of data;track list){
  <div class="history-list cursor-pointer flex-column">
    <div class="d-flex justify-content-between" (click)="onExpandClick($index)">
      <span class="title">Update History {{ $index + 1 }}</span>
      <img src="../../../assets/images/arrow-line-white.svg" />
    </div>
  </div>

  <!-- }  -->
  @if(data[$index].expanded){
  <!-- @for(item of data;track item){ -->
  <div class="content-div">
    <div class="first-div d-flex flex-column">
      <!-- <div class="personal-info"> -->
      <div class="heading">
        <span class="grid-head">Personal Details</span>
        <!-- </div> -->
      </div>
      <div class="info-details d-flex">
        <div class="details d-flex justify-content-between">
          <span class="details-head">Name</span>
          <span class="details-data"
            >{{ data[$index].phl_mem_name }}&nbsp;{{
              data[$index].phl_mem_surname
            }}</span
          >
        </div>
        <div class="details d-flex justify-content-between">
          <span class="details-head">Guardian's Name</span>
          <span class="details-data">{{
            data[$index].sug_guardian_name || "-"
          }}</span>
        </div>
        <div class="details d-flex justify-content-between">
          <span class="details-head">Ritwick's Name</span>
          <span class="details-data">{{
            data[$index].sug_ritwiki_name || "-"
          }}</span>
        </div>
      </div>
    </div>
    <div class="first-div d-flex flex-column">
      <!-- <div class="personal-info"> -->
      <div class="heading">
        <span class="grid-head">Initiation Information</span>
        <!-- </div> -->
      </div>
      <div class="info-details d-flex">
        <div class="details d-flex justify-content-between">
          <span class="details-head">Member Status</span>
          @if(data[$index].mem_status===2){
          <span class="details-data">Active</span>}@else{
          <span class="details-data">Inactive</span>
          }
        </div>
        <div class="details d-flex justify-content-between">
          <span class="details-head">Family Code</span>
          <span class="details-data">{{ data[$index].mem_family_code }}</span>
        </div>
        <div class="details d-flex justify-content-between">
          <span class="details-head">Contact Number</span>
          <span class="details-data">{{
            data[$index].mem_contact_no || "-"
          }}</span>
        </div>
        <div class="details d-flex justify-content-between">
          <span class="details-head">Email Address</span>
          <span class="details-data">{{ data[$index].mem_email || "-" }}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="content-div">
    <div class="first-div d-flex flex-column">
      <div class="heading">
        <span class="grid-head">Permanent Address</span>
        <!-- </div> -->
      </div>
      <div class="info-details d-flex">
        <div class="details d-flex justify-content-between">
          <span class="details-head">Address</span>
          <span class="details-data">{{
            data[$index].mem_address_permanent_line1 || "-"
          }}</span>
        </div>
        <div class="details d-flex justify-content-between">
          <span class="details-head">Landmark</span>
          <span class="details-data">{{
            data[$index].mem_address_permanent_line2 || "-"
          }}</span>
        </div>
        <div class="details d-flex justify-content-between">
          <span class="details-head">Pincode</span>
          <span class="details-data">{{
            data[$index].mem_perm_pin || "-"
          }}</span>
        </div>
        <div class="details d-flex justify-content-between">
          <span class="details-head">PostOffice</span>
          <span class="details-data">{{
            data[$index].mem_perm_po || "-"
          }}</span>
        </div>
        <div class="details d-flex justify-content-between">
          <span class="details-head">District</span>
          <span class="details-data">{{
            data[$index].mem_perm_district_name || "-"
          }}</span>
        </div>
        <div class="details d-flex justify-content-between">
          <span class="details-head">state</span>
          <span class="details-data">{{
            data[$index].mem_perm_state_name || "-"
          }}</span>
        </div>
      </div>
    </div>
    <div class="first-div d-flex flex-column">
      <!-- <div class="personal-info"> -->
      <div class="heading">
        <span class="grid-head">Present Address</span>
        <!-- </div> -->
      </div>
      <div class="info-details d-flex">
        <div class="details d-flex justify-content-between">
          <span class="details-head"> Address</span>
          <span class="details-data">{{
            data[$index].mem_address_present_line1 || "-"
          }}</span>
        </div>
        <div class="details d-flex justify-content-between">
          <span class="details-head">Landmark</span>
          <span class="details-data">{{
            data[$index].mem_address_present_line2 || "-"
          }}</span>
        </div>
        <div class="details d-flex justify-content-between">
          <span class="details-head">Pincode</span>
          <span class="details-data">{{
            data[$index].mem_present_pin || "-"
          }}</span>
        </div>
        <div class="details d-flex justify-content-between">
          <span class="details-head">PostOffice</span>
          <span class="details-data">{{
            data[$index].mem_present_po || "-"
          }}</span>
        </div>
        <div class="details d-flex justify-content-between">
          <span class="details-head">District</span>
          <span class="details-data">{{
            data[$index].mem_present_district_name || "-"
          }}</span>
        </div>
        <div class="details d-flex justify-content-between">
          <span class="details-head">state</span>
          <span class="details-data">{{
            data[$index].mem_present_state_name || "-"
          }}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="content-div">
    <div class="last-div d-flex flex-column">
      <div class="heading">
        <span class="grid-head">Summary (Comments)</span>
      </div>
      <div class="info-details d-flex">
        <span class="details-head">{{ data[$index].mem_comments || "-" }}</span>
      </div>
    </div>
  </div>
  } }
</div>
